var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2300",
    d: "M0.518233 2.77735C0.296715 2.44507 0.534911 2 0.934259 2H7.06574C7.46509 2 7.70328 2.44507 7.48177 2.77735L4.41603 7.37596C4.21811 7.67283 3.78189 7.67283 3.58397 7.37596L0.518233 2.77735Z",
    fill: "#C1C8D0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandArrowIcon);
export default __webpack_public_path__ + "static/media/expand-arrow-icon.0d1921a9650099eb58a31a7905de857c.svg";
export { ForwardRef as ReactComponent };